import {createReducer, on} from '@ngrx/store';
import {
  ClearParticipantFilterRequest,
  ClearState, FetchGroupFilterFailure, FetchGroupFilterRequest, FetchGroupFilterSuccess,
  FetchGroupsListFailure,
  FetchGroupsListRequest,
  FetchGroupsListSuccess,
  FetchGroupsStatusFilterFailure,
  FetchGroupsStatusFilterRequest,
  FetchGroupsStatusFilterSuccess,
  FetchGroupsTypeFilterFailure,
  FetchGroupsTypeFilterRequest,
  FetchGroupsTypeFilterSuccess,
  FetchParticipantFilterFailure,
  FetchParticipantFilterRequest,
  FetchParticipantFilterSuccess,
  GenerateAttendanceReportFailure,
  GenerateAttendanceReportRequest,
  GenerateAttendanceReportSuccess
} from './coach-groups-list.actions';
import {GroupsList} from '../../../../models/groups-list';
import {Filter} from '../../../../models/filter';
import {DropdownOption} from '../../../../models/dropdown-option.model';

// State for this feature (User)
export interface CoachGroupsListState {
  groupsList: GroupsList;
  groupsTypeFilter: Filter;
  groupsStatusFilter: Filter;
  participantFilter: {
    list?: DropdownOption[],
    total?: number,
    pageNumber?: number,
    limit?: number,
    hasNext?: boolean,
    hasPrev?: boolean
    loading?: boolean
  };
  groupFilter: {
    list?: DropdownOption[],
    total?: number,
    pageNumber?: number,
    limit?: number,
    hasNext?: boolean,
    hasPrev?: boolean
    loading?: boolean
  }
}

const initialState: CoachGroupsListState = {
  groupsList: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  groupsTypeFilter: {
    list: [],
    total: 0,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  groupsStatusFilter: {
    list: [],
    total: 0,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  participantFilter: {
    list: [],
    total: 0,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  groupFilter: {
    list: [],
    total: 0,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  }
};

export const reducer = createReducer(
  initialState,

  // CLEAR STATE
  on(ClearState, (state) => initialState),

  // FETCH GROUPS LIST
  on(FetchGroupsListRequest, (state, props) => ({
    ...state,
    groupsList: {
      ...state.groupsList,
      list: [
        ...(
          props.payload?.pageNumber ?
          props.payload?.pageNumber === 1 ? [] : [...state.groupsList.list] :
            []
        )
      ],
      loading: true
    }
  })),
  on(FetchGroupsListSuccess, (state, props) => ({
    ...state,
    groupsList: {
      ...props.groupsList,
      loading: false,
      list: [
        ...(props.groupsList?.pageNumber === 1 ? [
          ...props.groupsList?.list
        ] : [
          ...state.groupsList?.list,
          ...props.groupsList?.list
        ])
      ]
    }
  })),
  on(FetchGroupsListFailure, (state) => ({
    ...state,
    groupsList: {
      ...state.groupsList,
      hasNext: false,
      hasPrev: false,
      loading: false
    }
  })),

  // FETCH GROUPS TYPE FILTER
  on(FetchGroupsTypeFilterRequest, (state) => ({
    ...state,
    groupsTypeFilter: {
      ...initialState.groupsTypeFilter,
      loading: true
    }
  })),
  on(FetchGroupsTypeFilterSuccess, (state, props) => ({
    ...state,
    groupsTypeFilter: {
      ...props.groupsTypeFilter,
      loading: false
    }
  })),
  on(FetchGroupsTypeFilterFailure, (state) => ({
    ...state,
    groupsTypeFilter: {
      ...initialState.groupsTypeFilter,
      loading: false
    }
  })),

  // FETCH GROUPS STATUS FILTER
  on(FetchGroupsStatusFilterRequest, (state) => ({
    ...state,
    groupsStatusFilter: {
      ...initialState.groupsStatusFilter,
      loading: true
    }
  })),
  on(FetchGroupsStatusFilterSuccess, (state, props) => ({
    ...state,
    groupsStatusFilter: {
      ...props.groupsStatusFilter,
      loading: false
    }
  })),
  on(FetchGroupsStatusFilterFailure, (state) => ({
    ...state,
    groupsStatusFilter: {
      ...initialState.groupsStatusFilter,
      loading: false
    }
  })),

  on(GenerateAttendanceReportRequest, state => state),
  on(GenerateAttendanceReportSuccess, state => state),
  on(GenerateAttendanceReportFailure, state => state),

  // Participant filter
  on(ClearParticipantFilterRequest, (state) => ({
    ...state,
    participantFilter: initialState.participantFilter
  })),

  on(FetchParticipantFilterRequest, (state, props) => ({
    ...state,
    participantFilter: {
      loading: true,
      ...(props.payload.pageNumber ? props.payload.pageNumber === 1 ? {
          list: []
        } : {
          list: state.participantFilter?.list || []
        } : []
      )
    }
  })),

  on(FetchParticipantFilterSuccess, (state, props) => ({
    ...state,
    participantFilter: {
      ...props.payload,
      loading: false,
      ...(
        props.payload.pageNumber ?
        props.payload.pageNumber === 1 ? {
          list: props.payload.list
        } : {
          list: [
            ...state?.participantFilter?.list || [],
            ...props.payload.list
          ]
        } : []
      )
    }
  })),


  on(FetchParticipantFilterFailure, state => ({
    ...state,
    participantFilter: {
      list: [],
      loading: false
    }
  })),

  // Group filter
  on(FetchGroupFilterRequest, (state, props) => ({
    ...state,
    groupFilter: {
      loading: true,
      ...(props.payload?.pageNumber ? props.payload.pageNumber === 1 ? {
          list: []
        } : {
          list: state.groupFilter?.list || []
        } : []
      )
    }
  })),

  on(FetchGroupFilterSuccess, (state, props) => ({
    ...state,
    groupFilter: {
      ...props.payload,
      loading: false,
      ...(
        props.payload.pageNumber ?
        props.payload.pageNumber === 1 ? {
          list: props.payload.list
        } : {
          list: [
            ...state?.groupFilter?.list || [],
            ...props.payload.list
          ]
        } : []
      )
    }
  })),


  on(FetchGroupFilterFailure, state => ({
    ...state,
    groupFilter: initialState.groupFilter
  }))
);
